export default __webpack_public_path__ + "access-matrix.png";